<template>
  <div>
    <loader :isLoading="isLoading"  />
    <router-view v-show="!isLoading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '../../../components/common/Loader.vue';

export default {
  components: {
    Loader,
  },
  computed: {
    ...mapState('theme', ['theme']),
    ...mapState('installments', ['isLoading']),
  },
  watch: {
    theme(newValue) {
      document.documentElement.setAttribute('theme', newValue);
    },
  },
};
</script>
